export default __webpack_public_path__ + "static/media/grocery-LP.8d936093.svg";